import { objectOf, maybe, arrayOf } from "@altostra/type-validations";
import { boolean, number, string, any } from "@altostra/type-validations/lib/primitives";

export const isScheduleData = objectOf({
  start_date_time: maybe(number),
  display_text: maybe(string),
  frequency: string,
  weekdays: maybe(any),
  deliver_in_local_time: maybe(boolean),
  optimal_time_notification: maybe(boolean),
  recurring: maybe(boolean),
  repeat_interval: maybe(number),
});

export const isEngagementPredictionCloneResult = objectOf({
  id: string,
  name: string,
  description: maybe(string),
  model_type: string,
  app_group_id: string,
  marked_as_deleted: maybe(boolean),
  impersonation_only: boolean,
  demo_model: boolean,
  training_failure_message: maybe(string),
  scheduleData: maybe(isScheduleData),
  time_window: maybe(number),
  condition_filters_data: maybe(any),
  universe_filters_data: maybe(any),
  last_edited: maybe(number),
  last_trained: maybe(number),
  last_predicted: maybe(number),
  next_predict: maybe(number),
  preview_model: maybe(boolean),
  use_snowflake: maybe(boolean),
  slow_training: maybe(boolean),
  workflow_names: maybe(arrayOf(string)),
  segment_names: maybe(arrayOf(string)),
  campaign_names: maybe(arrayOf(string)),
});
